import React from "react";
import { Drawer } from "antd";
import { NavigationMenu } from "./navigation-menu";
import HeaderTop from "./header-top";
import { HamburgerMenu } from "../../../components/hamburger-menu";
import "./header-menu.scss";

interface HeaderMenuProps {
    isScrollBackBtnVisible: boolean;
}

interface HeaderMenuState {
    CurrentItem: string;
    IsToggleMenuVisible: boolean;
}


class HeaderMenu extends React.Component<HeaderMenuProps, HeaderMenuState>{
    constructor(props: any) {
        super(props);
        this.state = {
            CurrentItem: "home",
            IsToggleMenuVisible: false
        };
    }

    onClickMenuItem = (e: any) => {
        this.setState({ CurrentItem: e });
    }


    onCloseToggleMenu = () => {
        this.setState({ IsToggleMenuVisible: false })
    }

    openToggleMenu = () => {
        this.setState({ IsToggleMenuVisible: true });
    };

    render() {
        return (
            <header className="header">
                <div className={this.props.isScrollBackBtnVisible ? "header__wrapper header--hidden" : "header__wrapper"}>
                    <div className="header__content">
                        <HeaderTop />
                    </div>
                    <div className="header__hamburger-menu-content">
                        <HamburgerMenu onClickHamburgerMenu={this.openToggleMenu} isToggleMenuVisible={this.state.IsToggleMenuVisible} />
                    </div>
                </div>
                <div className="nav-container">
                    <div className="navigation-menu-content">
                        <NavigationMenu isNavMenuVisible={true} isToggleMenuVisible={false} />
                    </div>

                    <Drawer
                        width={"100%"}
                        title={null}
                        placement="right"
                        closable={false}
                        onClose={this.onCloseToggleMenu}
                        open={this.state.IsToggleMenuVisible}
                        className="navigation-menu__drawer"
                        motion={{ motionDeadline: 20 }}
                    >
                        <HamburgerMenu onClickHamburgerMenu={this.onCloseToggleMenu} isToggleMenuVisible={this.state.IsToggleMenuVisible} />
                        <NavigationMenu isToggleMenuVisible={true} isNavMenuVisible={false} onCloseNavigationMenu={this.onCloseToggleMenu} />
                    </Drawer>
                </div >
            </header>
        );
    }
}

export default HeaderMenu;